import { forwardRef } from "react";

import { Button, type ButtonProps } from "./button";

export const PrimaryButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      children,
      onClick,
      isDisabled,
      size,
      type,
      loading,
      ...props
    }: ButtonProps,
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        className={className}
        variant="primary"
        isDisabled={isDisabled}
        onClick={onClick}
        size={size}
        type={type}
        loading={loading}
        {...props}
      >
        {children}
      </Button>
    );
  },
);
